/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider, useSelector } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import { getTheme, getUser } from '../../../store/common/common.selectors'
import { Theme } from '@mui/material'
import { FacebookPage } from '@3m5/sm_publish-frontend-api'
import { getFacebookPage } from '../../../store/dashboard/dashboard.selector'

// FacebookSettings
import ProfessocialFacebookSettings from '@professocial/professocialFacebookSettings/src/screens/ProfessocialFacebookSettings'
import { facebookSettingsRootReducer } from '@professocial/professocialFacebookSettings/src/store/facebookSettingsRoot.reducer'
import { facebookSettingsRootSagas } from '@professocial/professocialFacebookSettings/src/store/facebookSettingsRoot.sagas'

// NetworkContent
const sagaMiddleware = createSagaMiddleware()
const storeFacebookSettings = createStore(
  facebookSettingsRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(facebookSettingsRootSagas)

const UserFacebookSettings: React.FC = () => {
  const user: UserSettings | undefined = useSelector(getUser)
  const theme: Theme = useSelector(getTheme)
  const facebookPage: FacebookPage | undefined = useSelector(getFacebookPage)

  return (
    <Provider store={storeFacebookSettings}>
      <ProfessocialFacebookSettings facebookSettingsConfiguration={{ facebookPage, user, theme }} />
    </Provider>
  )
}
export default UserFacebookSettings
